export const TOOLTIP_OFFSET_Y = -10;

export const TOOLTIP_ENTER_DELAY = 300;
